/**
 * Sparxs Catalog filter, period, and column-sort constants.
 */

export const DEFAULT_FILTER_ALL = "All";

/** Catalog statistics period query values (matches backend PeriodEnum). */
export const CATALOG_PERIOD = {
  ALL: "ALL",
  ONE: "1",
  TWO: "2",
  THREE: "3",
} as const;

export type CatalogPeriod =
  (typeof CATALOG_PERIOD)[keyof typeof CATALOG_PERIOD];

export const PERIOD_OPTIONS_LIST = [
  CATALOG_PERIOD.ALL,
  CATALOG_PERIOD.ONE,
  CATALOG_PERIOD.TWO,
  CATALOG_PERIOD.THREE,
] as const;

export const DEFAULT_PERIOD: CatalogPeriod = CATALOG_PERIOD.ONE;

export const CATALOG_SORT_COLUMNS = {
  NAME: "name",
  CATEGORY: "category",
  IMPRESSIONS: "impressions",
  CLICKS: "clicks",
  ENGAGEMENT_RATE: "engagementRate",
  ACTIVE: "active",
} as const;

export type CatalogSortColumn =
  (typeof CATALOG_SORT_COLUMNS)[keyof typeof CATALOG_SORT_COLUMNS];

export const CATALOG_SORT_DIRECTIONS = {
  ASC: "asc",
  DESC: "desc",
} as const;

export type CatalogSortDirection =
  | (typeof CATALOG_SORT_DIRECTIONS)[keyof typeof CATALOG_SORT_DIRECTIONS]
  | null;

export const DEFAULT_CATALOG_SORT_COLUMN: CatalogSortColumn =
  CATALOG_SORT_COLUMNS.NAME;

export const DEFAULT_CATALOG_SORT_DIRECTION: CatalogSortDirection =
  CATALOG_SORT_DIRECTIONS.ASC;

export const STATUS_FILTER_OPTIONS = {
  ALL: "All",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
} as const;

export type StatusFilterOption =
  (typeof STATUS_FILTER_OPTIONS)[keyof typeof STATUS_FILTER_OPTIONS];

export const STATUS_FILTER_OPTIONS_LIST = [
  STATUS_FILTER_OPTIONS.ALL,
  STATUS_FILTER_OPTIONS.ACTIVE,
  STATUS_FILTER_OPTIONS.INACTIVE,
] as const;

export const DEFAULT_STATUS_FILTER: StatusFilterOption =
  STATUS_FILTER_OPTIONS.ALL;

export const FILTER_TYPES = {
  CATEGORY: "category",
  STATUS: "status",
} as const;

export type FilterType = (typeof FILTER_TYPES)[keyof typeof FILTER_TYPES];

export const SPARXS_CATALOG_TABLE_SKELETON_ROW_COUNT = 12;
